import { useEffect, useState } from "react";
import useDevice from "../hooks/useDevice";
import Text from "./Text";
import Select from "./Select";

type OptionData = {
    text: string;
    value: string;
    default?: boolean;
}

type CommonSelectProps = {
    url?: string;
    parentId?: string;
    label?: string;
    name?: string;
    value: string;
    data: OptionData[];
    isModal: boolean;
    all?: boolean;
    required?: boolean;
    onChange: (val: string) => void;
};

type RequestType = {
    url: string;
    parentId: string;
};

function CommonSelect({
    url = "",
    parentId = "",
    label = "",
    value,
    name = "commonSelect",
    all,
    data,
    required = false,
    isModal = false,
    onChange
}: CommonSelectProps) {

    const device = useDevice();
    const isMobile = device !== 'desktop'


    const mappedOptions =
        data?.map((item: any) => ({
            text: item.text,
            value: item.value,
            default: item.value === value
        })) ?? [];

    const options = [
        ...(all ? [{ text: "전체", value: "", default: value === "" }] : []),
        ...mappedOptions
    ];


    return (
        <div style={{ 
                display: "flex", 
                alignItems: isModal ? "flex-start" : "center", 
                flexDirection: isModal ? "column" : "row",
                gap: isModal ? 8 : 0,
                width: "100%",
            }}>
            <Text size={isModal ? "md" : "sm"} style={{ width: "70px", flexShrink: 0 }}>
                {label} {required && <em style={{color: "rgba(62, 99, 237, 1)"}}>*</em>}
            </Text>

            <Select
                key={value}
                name={name}
                fullWidth
                value={value}
                options={options}
                onChange={onChange}
                style={{flex: 1, minHeight: 0}}
            />
        </div>
    );
}

export default CommonSelect;
